import React, { CSSProperties, FC } from 'react';
import { ErrorMessage, Field, FieldInputProps } from 'formik';
import { Form } from 'semantic-ui-react';

interface FieldTextProps {
    name: string;
    title: string;
    placeholder?: string;
    required?: boolean;
    size?: 'mini' | 'small' | 'large' | 'big' | 'huge' | 'massive';
    style?: CSSProperties;
    disabled?: boolean;
}

const FieldText: FC<FieldTextProps> = ({
    name,
    title,
    placeholder,
    required,
    size,
    style,
    disabled
}: FieldTextProps) => {
    return (
        <>
            <Field name={name}>
                {({ field }: { field: FieldInputProps<string> }) => (
                    <Form.Input
                        fluid
                        label={title + (required ? ' *' : '')}
                        placeholder={placeholder || title}
                        value={field.value || ''}
                        onChange={field.onChange}
                        id={field.name}
                        onBlur={field.onBlur}
                        style={style}
                        size={size}
                        disabled={disabled}
                    />
                )}
            </Field>
            <ErrorMessage
                name={name}
                createRoot={(errorMessage: any) => <span className="required">{errorMessage}</span>}
            />
        </>
    );
};

export default FieldText;
